<div class="document-uploader" [class.d-none]="image">
    <label [for]="'dropzone-file-' + key">
        <div>
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                ></path>
            </svg>
            <p class="document-uploader__unique1">
                <span>{{ "AFFILIATIONS.DOCS-SELECT-IMAGE" | translate }}</span>
            </p>
            <p class="document-uploader__unique2">SVG, PNG, JPG.</p>
        </div>
        <input
            [id]="'dropzone-file-' + key"
            type="file"
            accept="image/apng, image/avif, image/gif, image/jpeg, image/png, image/svg+xml, image/webp"
            (change)="onFileChange.emit($event)"
            multiple="false"
        />
    </label>
</div>
<div class="document-uploader-preview" *ngIf="image">
    <img [src]="image" />
    <nb-alert status="basic" size="small" class="flex-row" *ngIf="showHint">
        <nb-icon
            icon="alert-circle-outline"
            class="mr-2 d-none d-md-inline-block"
            style="font-size: 18px; flex-shrink: 0"
        ></nb-icon>
        <p class="paragraph m-0">
            {{ "GENERAL.IMG-UPLOADER-HINT" | translate }}
        </p>
    </nb-alert>
</div>
<div class="d-flex justify-content-center mt-2">
    <button nbButton status="info" outline size="small" class="mr-2" *ngIf="image" (click)="onReplace.emit()">
        <nb-icon icon="refresh-outline"></nb-icon>
        {{ "BUTTONS.REPLACE" | translate }}
    </button>
    <button
        nbButton
        status="danger"
        outline
        size="small"
        class="mr-2"
        *ngIf="image && isUrl(image)"
        (click)="onDelete.emit()"
        [disabled]="disableDelete"
    >
        <nb-icon icon="trash-2-outline"></nb-icon>
        {{ "BUTTONS.DELETE" | translate }}
    </button>
</div>
